/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Catalog_Template_DefaultInputs */

const cs_property_ai_catalog_template_default = /** @type {(inputs: Property_Ai_Catalog_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí organizace`)
};

const en_property_ai_catalog_template_default = /** @type {(inputs: Property_Ai_Catalog_Template_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Org default`)
};

/**
* | output |
* | --- |
* | "Org default" |
*
* @param {Property_Ai_Catalog_Template_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_catalog_template_default = /** @type {((inputs?: Property_Ai_Catalog_Template_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Catalog_Template_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_catalog_template_default(inputs)
	return cs_property_ai_catalog_template_default(inputs)
});